import {Component, OnInit} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { PreviousRouteService } from './core/services/previous-route.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cm-manager',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private previousRouteService: PreviousRouteService,
    translate: TranslateService
  ) {
    // Nothing loads a language until after login (auth sets the user's
    // locale), so pre-login screens need the default to be active here.
    translate.setDefaultLang('en-GB');
    this.iconRegistry.addSvgIconSetInNamespace(
      'cm',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        '/assets/icons/cm-icons.svg'
      )
    );
  }

  ngOnInit(): void {
  }
}
